import { atom } from "jotai"

// Base atoms
export const roleAtom = atom('youth')
export const availableRolesAtom = atom(['youth'])
export const planTokenAtom = atom(null)
export const userAtom = atom(null)
// redirectAtom persists to sessionStorage to survive page reloads/magic link clicks
export const redirectAtom = atom(
  sessionStorage.getItem('encircled_redirect'),
  (get, set, value) => {
    if (value) {
      sessionStorage.setItem('encircled_redirect', value)
    } else {
      sessionStorage.removeItem('encircled_redirect')
    }
    set(redirectAtom, value)
  }
)
// lastPlanTokenAtom persists to localStorage to remember the last viewed plan
export const lastPlanTokenAtom = atom(
  localStorage.getItem('encircled_last_plan_token'),
  (get, set, value) => {
    if (value) {
      localStorage.setItem('encircled_last_plan_token', value)
    } else {
      localStorage.removeItem('encircled_last_plan_token')
    }
    set(lastPlanTokenAtom, value)
  }
)
// onboardingAtom persists registration and plan creation flow data to sessionStorage
export const onboardingAtom = atom(
  JSON.parse(sessionStorage.getItem('encircled_onboarding') || 'null'),
  (get, set, value) => {
    if (value) {
      sessionStorage.setItem('encircled_onboarding', JSON.stringify(value))
    } else {
      sessionStorage.removeItem('encircled_onboarding')
    }
    set(onboardingAtom, value)
  }
)

export const isOrgAdminAtom = atom((get) => {
  const user = get(userAtom)
  return !!(user?.is_admin && !user?.is_super_admin)
})
export const isSuperAdminAtom = atom((get) => {
  const user = get(userAtom)
  return !!(user?.is_admin && user?.is_super_admin)
})
export const isGuideAdminAtom = atom((get) => {
  const user = get(userAtom)
  return !!(user?.is_guide_admin && !user?.is_admin)
})
export const isGuideAtom = atom((get) => {
  const user = get(userAtom)
  return !!(user?.is_guide && !user?.is_admin && !user?.is_guide_admin)
})
export const deleteConfirmationAtom = atom(null)
export const loadingAtom = atom(true)
export const channelAtom = atom(null)
export const isEditingStepAtom = atom(false)

// Re-export plan(s)-related atoms
export { planAtom, fetchPlanAtom } from './plan'
export { plansAtom, filteredPlansAtom, fetchPlansAtom, refetchPlansAtom } from './plans'